var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    { staticClass: "pa-4", attrs: { dense: "", justify: "space-between" } },
    [
      _c("v-col", { attrs: { "data-cy": "fileinfo", cols: "11" } }, [
        _c("strong", [_vm._v("Filename:")]),
        _vm._v(" " + _vm._s(_vm.filename)),
        _c("br"),
        _vm.inspec_version
          ? _c("div", [
              _c("strong", [_vm._v("Tool Version:")]),
              _vm._v(" " + _vm._s(_vm.inspec_version) + " "),
            ])
          : _vm._e(),
        _vm.platform
          ? _c("div", [
              _c("strong", [_vm._v("Platform:")]),
              _vm._v(" " + _vm._s(_vm.platform)),
            ])
          : _vm._e(),
        _vm.duration
          ? _c("div", [
              _c("strong", [_vm._v("Duration:")]),
              _vm._v(" " + _vm._s(_vm.duration) + " Seconds "),
            ])
          : _vm._e(),
        _vm.startTime
          ? _c("div", [
              _c("strong", [_vm._v("Start Time:")]),
              _vm._v(" " + _vm._s(_vm.startTime)),
            ])
          : _vm._e(),
        _vm.evaluation
          ? _c(
              "div",
              { staticClass: "d-flex flex-nowrap" },
              [
                _c("strong", { staticClass: "pt-2 pr-1" }, [_vm._v("Tags:")]),
                _vm.evaluation.id
                  ? _c("TagRow", { attrs: { evaluation: _vm.evaluation } })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.evaluation && _vm.evaluation.groups.length !== 0
          ? _c(
              "div",
              { staticClass: "d-flex flex-nowrap" },
              [
                _c("strong", { staticClass: "pt-2 pr-1" }, [_vm._v("Groups:")]),
                _c("GroupRow", { attrs: { evaluation: _vm.evaluation } }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("v-col", { attrs: { cols: "1" } }, [
        _vm.file.from_file.database_id &&
        _vm.evaluation &&
        _vm.evaluation.editable
          ? _c(
              "div",
              { staticClass: "top-right" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-3 mt-3",
                    attrs: { "data-cy": "edit", title: "Edit" },
                    on: {
                      click: function ($event) {
                        _vm.showEditEvaluationModal = true
                      },
                    },
                  },
                  [_vm._v(" mdi-pencil ")]
                ),
                _vm.evaluation && _vm.showEditEvaluationModal
                  ? _c("EditEvaluationModal", {
                      attrs: {
                        id: "editEvaluationModal",
                        visible: _vm.showEditEvaluationModal,
                        active: _vm.evaluation,
                      },
                      on: {
                        close: function ($event) {
                          _vm.showEditEvaluationModal = false
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }